import React from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';

interface LoadMoreBarProps {
  count: number;
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}

/**
 * Footer for cursor-paginated tables: shows the loaded-row count and a
 * "Load more" action. No total count (cheap at scale).
 */
const LoadMoreBar: React.FC<LoadMoreBarProps> = ({ count, hasMore, loading, onLoadMore }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, py: 2, flexWrap: 'wrap' }}>
    <Typography variant="caption" color="text.secondary">
      Showing {count} {count === 1 ? 'row' : 'rows'}
    </Typography>
    {hasMore ? (
      <Button
        variant="outlined"
        size="small"
        onClick={onLoadMore}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={14} color="inherit" /> : undefined}
      >
        {loading ? 'Loading…' : 'Load more'}
      </Button>
    ) : (
      count > 0 && <Typography variant="caption" color="text.secondary">· end of results</Typography>
    )}
  </Box>
);

export default LoadMoreBar;
